/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccountModel = {
    AccountNumber?: string;
    AccountName?: string;
    AccountId?: string;
    Description?: string;
    ReferrerCode?: string;
    AccountType?: AccountModel.AccountType;
    AccountStatus?: string;
    LevyCode?: string;
    IsBillable?: boolean;
    IsInherited?: boolean;
    OriginalAccountRMDStatus?: AccountModel.OriginalAccountRMDStatus;
    IsSpousal?: boolean;
    IsInRMDStatus?: boolean | null;
    OpenDate?: string | null;
    ClosedDate?: string | null;
    ResignedDate?: string | null;
    CashBalance?: number;
    MinimumCashBalance?: number;
    TotalOutstandingFees?: number;
};
export namespace AccountModel {
    export enum AccountType {
        UNKNOWN = 'Unknown',
        TRADITIONAL_IRA = 'TraditionalIra',
        SEP_IRA = 'SepIra',
        ROTH_IRA = 'RothIra',
        SIMPLE_IRA = 'SimpleIra',
        KEOGH = 'Keogh',
        COVERDELL_EDUCATION_SAVINGS = 'CoverdellEducationSavings',
        SAR_SEP = 'SarSep',
        SOLO_TRADITIONAL401K = 'SoloTraditional401k',
        SOLO_ROTH401K = 'SoloRoth401k',
        SOLO401K = 'Solo401k',
        ALT_SOLO401K = 'AltSolo401k',
        PFC = 'Pfc',
    }
    export enum OriginalAccountRMDStatus {
        UNKNOWN = 'Unknown',
        BENEFICIARY_BEFORE_RMD = 'BeneficiaryBeforeRMD',
        BENEFICIARY_AFTER_RMD = 'BeneficiaryAfterRMD',
    }
}

